import { idTypesConstants } from "../constants/action.constants";
import { idTypeService } from "../services/idtypes.service";
import { alertActions } from "../../Alert/actions/alert.actions";
import { message, routeConstants } from "../../../_constants";
import { history } from "../../../_utils";

export const idTypeActions = {
  addIdType,
  getAllIdTypes,
  getIdType,
  resetIdType,
  resetAddIdType
};

function getAllIdTypes() {
  return async dispatch => {
    dispatch(request());
    try {
      const response = await idTypeService.getAllIdTypes();
      response && dispatch(success(response));
    } catch (error) {
      dispatch(failure(error));
      dispatch(
        alertActions.error(
          error ? error.message : message.GENERIC_ERROR,
          message.LOAD_IDTYPES
        )
      );
    }
  };

  function request() {
    return { type: idTypesConstants.GET_IDTYPES_REQUEST };
  }
  function success(response) {
    return { type: idTypesConstants.GET_IDTYPES_SUCCESS, response };
  }
  function failure(error) {
    return { type: idTypesConstants.GET_IDTYPES_FAILURE, error };
  }
}

function getIdType(id) {
  return async dispatch => {
    dispatch(request(id));
    try {
      const response = await idTypeService.getIdType(id);
      response && dispatch(success(response));
    } catch (error) {
      dispatch(failure(error));
      dispatch(
        alertActions.error(
          error ? error.message : message.GENERIC_ERROR,
          `${message.GET_IDTYPE}: ${id}`
        )
      );
    }
  };

  function request(id) {
    return { type: idTypesConstants.VIEW_IDTYPE_REQUEST, id };
  }
  function success(response) {
    return { type: idTypesConstants.VIEW_IDTYPE_SUCCESS, response };
  }
  function failure(error) {
    return { type: idTypesConstants.VIEW_IDTYPE_FAILURE, error };
  }
}

function addIdType(requestBody) {
  return async dispatch => {
    dispatch(request(requestBody));
    try {
      const response = await idTypeService.addIdType(requestBody);
      response && dispatch(success(response));
      dispatch(getAllIdTypes());
      if (requestBody.id) {
        history.push(routeConstants.IDTYPES.path);
      }
      dispatch(
        alertActions.success(
          response && response.responseMessage,
          requestBody.id ? message.EDIT_IDTYPE : message.ADD_IDTYPE
        )
      );
      dispatch(resetAddIdType());
      dispatch(resetIdType());
    } catch (error) {
      dispatch(failure(error));
      dispatch(
        alertActions.error(
          error ? error.message : message.GENERIC_ERROR,
          requestBody.id ? message.EDIT_IDTYPE : message.ADD_IDTYPE
        )
      );
    }
  };

  function request(requestBody) {
    return { type: idTypesConstants.ADD_IDTYPE_REQUEST, requestBody };
  }
  function success(response) {
    return { type: idTypesConstants.ADD_IDTYPE_SUCCESS, response };
  }
  function failure(error) {
    return { type: idTypesConstants.ADD_IDTYPE_FAILURE, error };
  }
}

function resetIdType() {
  return { type: idTypesConstants.VIEW_IDTYPE_RESET };
}

function resetAddIdType() {
  return { type: idTypesConstants.ADD_IDTYPE_RESET };
}
